// extracted by mini-css-extract-plugin
module.exports = {"quickViewButton":"_3MEjwx","productBase":"uah7kj"};